import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Button from "@mui/material/Button";
import { monFetch } from "../inc/inc";
import DeleteIcon from "@mui/icons-material/Delete";
import { useState, useEffect } from "react";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

import PopupElimina from "../elementi/PopupElimina";

const Comp = (props) => {

  const [sezioni, setSezioni] = useState([]);

  const [popupElimina, setPopupElimina] = useState(false);
  const [sezioneDaEliminare, setSezioneDaEliminare] = useState(null);

  async function query() {
    const res = await monFetch("/sectionList", {});
    setSezioni(res.section);
  }

  async function eliminaSezione(id) {
    const res = await monFetch("/sectionDelete", { id });
    setPopupElimina(false);
    query();
  }

  async function settaOrdinamento($idSezione, $direzione) {
    //$direzione 1 = porta dopo
    //$direzione 0 = porta prima
    const res = await monFetch("/sectionOrder", {
      direction: $direzione,
      section_id: $idSezione,
    });
    query();
  }

  useEffect(() => {
    props.setTestoTitolo(
      <>
        <Button
          variant="contained"
          className="buttonSalva"
          style={{ marginRight: 20 }}
          href={process.env.PUBLIC_URL + "/sezione-nuovo"}
        >
          Nuovo{" "}
        </Button>{" "}
        Lista Sezioni
      </>
    );
    query();
  }, []);

  return (
    <>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>#</TableCell>
            <TableCell>Nome</TableCell>
            <TableCell>Descrizione</TableCell>
            <TableCell></TableCell>
            <TableCell>Sottosezioni</TableCell>
            <TableCell>Domande</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sezioni.map((sezione, index) => {
            let mostraFrecciaSu = true;
            let mostraFrecciaGiu = true;
            if (index == 0) {
              mostraFrecciaSu = false;
            }
            if (index == sezioni.length - 1) {
              mostraFrecciaGiu = false;
            }

            return (
              <TableRow
                key={sezione.id}
                className="rigaSelezionabile"
                onClick={(e) => {
                  window.location.href = process.env.PUBLIC_URL + "/sezione/" + sezione.id;
                }}
              >
                <TableCell style={{ width: 50 }}>{sezione.order}</TableCell>
                <TableCell>{sezione.name}</TableCell>
                <TableCell>{sezione.description}</TableCell>
                <TableCell>
                  <a
                    onClick={(e) => {
                      e.stopPropagation();

                      // if(!mostraFrecciaSu){
                      //   return
                      // }

                      settaOrdinamento(sezione.id, 0);
                    }}
                  >
                    <KeyboardArrowUpIcon
                      style={{ opacity: mostraFrecciaSu ? 1 : 0.4 }}
                    />
                  </a>
                  <a
                    onClick={(e) => {
                      e.stopPropagation();
                      settaOrdinamento(sezione.id, 1);
                    }}
                  >
                    <KeyboardArrowDownIcon
                      style={{ opacity: mostraFrecciaGiu ? 1 : 0.4 }}
                    />
                  </a>
                </TableCell>
                <TableCell>{sezione.hasSubsection}</TableCell>
                <TableCell>{sezione.hasQuestion}</TableCell>
                <TableCell>
                  {sezione.hasSubsection > 0 ? (
                    <DeleteIcon
                      color="error"
                      style={{ opacity: 0.4 }}
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                    />
                  ) : (
                    <DeleteIcon
                      color="error"
                      onClick={(e) => {
                        e.stopPropagation();
                        setPopupElimina(true);
                        setSezioneDaEliminare(sezione.id);
                      }}
                    />
                  )}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
      <PopupElimina
        open={popupElimina}
        fnAnnulla={(e) => setPopupElimina(false)}
        fnSuccess={(e) => eliminaSezione(sezioneDaEliminare)}
      />
    </>
  );
};

export default Comp;
